import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, FormGroup, Label, Input, Form } from 'reactstrap';
import ViaticosService from "../../axios_services/viaticos.service";
import * as ViaticoSolicitudService from "../../axios_services/viaticosolicitud.service";

const ModalPlanillaViatico = ({ isOpen, onClose, onSave, planilla, periodoFiltro }) => {
    const initialState = {
        solicitud_id: '',
        viatico_id: '',
        dia_inicio: '',
        dia_fin: '',
        monto_pasaje: 0,
        monto_hospedaje: 0,
        monto_movilidad: 0,
        monto_alimentacion: 0,
        monto_adicional: 0,
        usuario_id: ''
    };

    const [formData, setFormData] = useState(initialState);
    const [isSaving, setIsSaving] = useState(false);
    const [solicitudes, setSolicitudes] = useState([]);
    const [viaticosCatalog, setViaticosCatalog] = useState([]);
    const [selectedEmpleadoId, setSelectedEmpleadoId] = useState('');

    useEffect(() => {
        if (isOpen) {
            fetchData();
        }
    }, [isOpen]);

    const fetchData = async () => {
        try {
            // Fetch Viaticos (lugares y montos)
            const viaticosRes = await ViaticosService.getViaticos();
            setViaticosCatalog(viaticosRes.data || []);
            
            // Fetch Solicitudes Aprobadas (Reporte)
            // Filtramos las que tienen validacion_id === 2 (Aprobadas por Jefe) para asignarles la planilla.
            const solicitudesRes = await ViaticoSolicitudService.getReporteSolicitudes();
            let aprobadas = (solicitudesRes.data || []).filter(s => Number(s.validacion_id) === 2 && !s.planilla_id);
            if (periodoFiltro) {
                aprobadas = aprobadas.filter(s => s.fecha_registro && s.fecha_registro.startsWith(periodoFiltro));
            }
            setSolicitudes(aprobadas);
        } catch (error) {
            console.error('Error fetching data for modal', error);
        }
    };

    useEffect(() => {
        if (planilla && isOpen) {
            setFormData({
                solicitud_id: planilla.solicitud_id || '',
                viatico_id: planilla.viatico_id || '',
                dia_inicio: planilla.dia_inicio || '',
                dia_fin: planilla.dia_fin || '',
                monto_pasaje: planilla.monto_pasaje || 0,
                monto_hospedaje: planilla.monto_hospedaje || 0,
                monto_movilidad: planilla.monto_movilidad || 0,
                monto_alimentacion: planilla.monto_alimentacion || 0,
                monto_adicional: planilla.monto_adicional || 0,
                usuario_id: planilla.usuario_id || ''
            });
        } else {
            setFormData(initialState);
            setSelectedEmpleadoId('');
        }
    }, [planilla, isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        let updatedData = { ...formData, [name]: value };

        // Auto-fill usuario_id si cambia solicitud_id
        if (name === 'solicitud_id') {
            const sol = solicitudes.find(s => s.solicitud_id.toString() === value);
            if (sol) {
                updatedData.usuario_id = sol.usuario_id;
            }
        }

        // Auto-fill montos si cambia viatico_id y las fechas están llenas
        if (name === 'viatico_id' || name === 'dia_inicio' || name === 'dia_fin') {
            recalcularMontos(updatedData);
        } else {
            setFormData(updatedData);
        }
    };

    const recalcularMontos = (data) => {
        let newData = { ...data };
        if (newData.viatico_id) {
            const viatico = viaticosCatalog.find(v => v.viatico_id.toString() === newData.viatico_id.toString());
            if (viatico) {
                let dias = 1;
                if (newData.dia_inicio && newData.dia_fin) {
                    const start = new Date(newData.dia_inicio);
                    const end = new Date(newData.dia_fin);
                    dias = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
                    if (dias < 1) dias = 1;
                }

                newData.monto_pasaje = (Number(viatico.pasaje) || 0);
                newData.monto_hospedaje = (Number(viatico.hospedaje) || 0) * dias;
                newData.monto_alimentacion = (Number(viatico.alimentacion) || 0) * dias;
                newData.monto_adicional = (Number(viatico.adicional) || 0);
                // monto_movilidad can be set to 0 or manual
            }
        }
        setFormData(newData);
    };

    const handleSubmit = async () => {
        if (!formData.solicitud_id && !planilla?.solicitud_id) {
            alert("Debe seleccionar una solicitud aprobada.");
            return;
        }
        if (!formData.viatico_id) {
            alert("Debe seleccionar un lugar (viático base).");
            return;
        }

        setIsSaving(true);
        try {
            await onSave(formData);
        } catch (error) {
            console.error("Error saving:", error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{planilla ? 'EDITAR PLANILLA DE VIÁTICO' : 'NUEVA PLANILLA DE VIÁTICO'}</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={(e) => e.preventDefault()}>
                        
                        <FormGroup>
                            <Label for="colaborador_id">Colaborador: <span className="text-danger">*</span></Label>
                            <Input
                                type="select"
                                name="colaborador_id"
                                id="colaborador_id"
                                value={planilla ? planilla.usuario_id : selectedEmpleadoId}
                                onChange={(e) => {
                                    setSelectedEmpleadoId(e.target.value);
                                    setFormData({ ...formData, solicitud_id: '', usuario_id: e.target.value });
                                }}
                                className="form-control"
                                disabled={!!planilla}
                            >
                                <option value="">Seleccione un Colaborador</option>
                                {planilla && (
                                    <option value={planilla.usuario_id}>{planilla.nombre_empleado}</option>
                                )}
                                {!planilla && Array.from(new Set(solicitudes.map(s => s.usuario_id))).map(id => {
                                    const emp = solicitudes.find(s => s.usuario_id === id);
                                    return (
                                        <option key={id} value={id}>
                                            {emp.nombre_empleado}
                                        </option>
                                    );
                                })}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label for="solicitud_id">Solicitud (Aprobada por Jefe Inmediato): <span className="text-danger">*</span></Label>
                            <Input
                                type="select"
                                name="solicitud_id"
                                id="solicitud_id"
                                value={formData.solicitud_id}
                                onChange={handleChange}
                                className="form-control"
                                disabled={!!planilla || !selectedEmpleadoId}
                            >
                                <option value="">Seleccione una Solicitud</option>
                                {planilla && (
                                    <option value={planilla.solicitud_id}>{planilla.asunto?.toUpperCase() || planilla.detalle_solicitud?.toUpperCase() || 'SIN DETALLE'}</option>
                                )}
                                {!planilla && solicitudes.filter(s => s.usuario_id.toString() === selectedEmpleadoId.toString()).map(s => {
                                    const asunto = s.asunto?.toUpperCase() || s.detalle_solicitud?.toUpperCase() || 'SIN ASUNTO';
                                    const asuntoCorto = asunto.length > 50 ? asunto.substring(0, 50) + '...' : asunto;
                                    return (
                                        <option key={s.solicitud_id} value={s.solicitud_id}>
                                            {asuntoCorto}
                                        </option>
                                    );
                                })}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label for="viatico_id">Lugar / Tipo Viático base: <span className="text-danger">*</span></Label>
                            <Input
                                type="select"
                                name="viatico_id"
                                id="viatico_id"
                                value={formData.viatico_id}
                                onChange={handleChange}
                                className="form-control"
                            >
                                <option value="">Seleccione el Lugar</option>
                                {viaticosCatalog.map(v => (
                                    <option key={v.viatico_id} value={v.viatico_id}>
                                        {v.lugar || 'Sin Lugar'} ({v.tipo_viatico?.toString() === '1' ? 'Colaborador' : 'Gerente'})
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>

                        <div style={{ display: 'flex', gap: '10px' }}>
                            <FormGroup style={{ flex: 1 }}>
                                <Label for="dia_inicio">Día Inicio: <span className="text-danger">*</span></Label>
                                <Input
                                    type="date"
                                    name="dia_inicio"
                                    id="dia_inicio"
                                    value={formData.dia_inicio}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </FormGroup>

                            <FormGroup style={{ flex: 1 }}>
                                <Label for="dia_fin">Día Fin: <span className="text-danger">*</span></Label>
                                <Input
                                    type="date"
                                    name="dia_fin"
                                    id="dia_fin"
                                    value={formData.dia_fin}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </FormGroup>
                        </div>

                        <FormGroup>
                            <Label for="monto_pasaje">Monto Pasaje (S/):</Label>
                            <Input
                                type="number"
                                name="monto_pasaje"
                                id="monto_pasaje"
                                value={formData.monto_pasaje}
                                onChange={handleChange}
                                step="0.01"
                                className="form-control"
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="monto_hospedaje">Monto Hospedaje (S/):</Label>
                            <Input
                                type="number"
                                name="monto_hospedaje"
                                id="monto_hospedaje"
                                value={formData.monto_hospedaje}
                                onChange={handleChange}
                                step="0.01"
                                className="form-control"
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="monto_alimentacion">Monto Alimentación (S/):</Label>
                            <Input
                                type="number"
                                name="monto_alimentacion"
                                id="monto_alimentacion"
                                value={formData.monto_alimentacion}
                                onChange={handleChange}
                                step="0.01"
                                className="form-control"
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="monto_movilidad">Monto Movilidad (S/):</Label>
                            <Input
                                type="number"
                                name="monto_movilidad"
                                id="monto_movilidad"
                                value={formData.monto_movilidad}
                                onChange={handleChange}
                                step="0.01"
                                className="form-control"
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="monto_adicional">Monto Adicional (S/):</Label>
                            <Input
                                type="number"
                                name="monto_adicional"
                                id="monto_adicional"
                                value={formData.monto_adicional}
                                onChange={handleChange}
                                step="0.01"
                                className="form-control"
                            />
                        </FormGroup>
                        
                        <FormGroup>
                            <div className="button-container pb-4">
                                <Button className="button-custom" onClick={handleSubmit} disabled={isSaving}>
                                    {isSaving ? 'GUARDANDO...' : 'GUARDAR'}
                                </Button>
                            </div>
                        </FormGroup>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalPlanillaViatico;
